import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-play\"><defs><style type=\"text/css\"></style></defs><path d=\"M422.4 713.6L691.2 512 422.4 310.4v403.2zM512 960c246.4 0 448-201.6 448-448s-201.6-448-448-448-448 201.6-448 448 201.6 448 448 448zM512 153.6c197.12 0 358.4 161.28 358.4 358.4s-161.28 358.4-358.4 358.4S153.6 709.12 153.6 512 314.88 153.6 512 153.6z\" p-id=\"3455\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol